import { AbandonedCartItemArray, AbandonedCartItem } from './../../models/ss-api/responses/abandoned.cart.item';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { SortBot } from '../../../app/helpers/sort';
import { Router } from '@angular/router';
import { Angular2Csv } from 'angular2-csv';
import { InvoiceDetailsDialog } from '../../../app/dialogs/invoice.details/invoice.details.dialog';

import * as moment from 'moment';
import { LicenseManager } from '../../managers/License.manager';
import { GlobalMACWhitelistBasic, GlobalMACWhitelistBasicArray } from '@models/ss-api/responses/global.mac.whitelist.basic';
import { AddGlobalMACWhitelist } from 'app/dialogs/add.global.mac.whitelist.dialog/add.global.mac.whitelist.dialog';

@Component({
    selector: 'tos-mac-whitelist',
    templateUrl: './tos.mac.whitelist.component.html',
    styleUrls: ['./tos.mac.whitelist.component.scss']
})

export class TOSMACWhitelistComponent implements OnInit {
    IsBusy: boolean = false;

    GlobalMACWhitelists: GlobalMACWhitelistBasicArray;
    MACFilter: string;

    constructor(private dialogService: DialogService,
        private api: ssApiService,
        private gb: GlobalService,
        private sweetAlert: SweetAlertService,
        private router: Router) { }

    ngOnInit() {
        this.gb.SetPageTitle('TOS MAC Whitelist');

        this.GetMACs();
    }

    sortBy(sortVar1, sortVar2?) {
        this.GlobalMACWhitelists = SortBot.SortAuto(this.GlobalMACWhitelists, sortVar1, sortVar2);
    }

    GetMACs() {
        this.IsBusy = true;
        let disposable = this.api.GetGlobalMACWhitelists().subscribe((response) => {
            if (response.Result) {
                this.GlobalMACWhitelists = response.Data;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Items',
                    text: response.Message
                }).then(() => { }, () => { });
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        });
    }

    DeleteItem(item: GlobalMACWhitelistBasic) {

        this.IsBusy = true;

        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'The MAC will no longer be whitelisted - tickets may be generated',
            showCancelButton: true
        }).then((response) => {
            this.IsBusy = false;
            let disposable = this.api.RemoveGlobalMACWhitelist(item.MACAddress).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'MAC Removed',
                        timer: 1500
                    }).then(() => { }, () => { });
                    this.GetMACs();
                } else {
                    this.sweetAlert.swal({
                        type: 'error',
                        title: 'Error',
                        text: response.Message
                    }).then(() => { }, () => { });
                }
                disposable.unsubscribe();
            });
        }, (dismiss) => {
            this.IsBusy = false;
        });





    }

    AddItem() {
        let disposable = this.dialogService.addDialog(AddGlobalMACWhitelist, {
            Title: 'Add Global MAC TOS Whitelist'
        }, { width: 600, height: 600 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.GetMACs();
            }
        });
    } 

}
